import { IonButton, IonButtons, IonCard, IonCardContent, IonCheckbox, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonItemDivider, IonLabel, IonModal, IonNote, IonPage, IonRadio, IonRadioGroup, IonRow, IonSelect, IonSelectOption, IonText, IonTextarea, IonTitle, IonToolbar, useIonAlert, useIonLoading, useIonRouter, useIonToast, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { add, navigateOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useAppContext } from '../AppProvider';
import PlaceCreateModal from './PlaceCreateModal'
import Alert from '@mui/material/Alert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { AlertTitle } from '@mui/material';

interface TrailCreateEmbedProps {
    nameRef: any;
    routeType: string;
    setRouteType: any;
    routeTextRef: any;
    routeStartTextRef: any;
    routeEndTextRef: any;
    onRouteNameChange?: (source: string, value: string) => void;
}

const TrailCreateEmbed: React.FC<TrailCreateEmbedProps> = ({ nameRef, routeType, setRouteType, routeTextRef, routeStartTextRef, routeEndTextRef, onRouteNameChange }) => {
    const [routeStartPlaceSrc, setRouteStartPlaceSrc] = useState<string>('');
    const [routeEndPlaceSrc, setRouteEndPlaceSrc] = useState<string>('');
    const [newRouteDetailOpen, setNewRouteDetailOpen] = useState<boolean>(false);
    const [endPlaceDisabled, setEndPlaceDisabled] = useState<boolean>(true);
    const [newStartPlaceIsOpen, setNewStartPlaceIsOpen] = useState<boolean>(false);
    const [newEndPlaceIsOpen, setNewEndPlaceIsOpen] = useState<boolean>(false);
    const [startPlaceTokenVal, setStartPlaceTokenVal] = useState<string>('');
    const [endPlaceTokenVal, setEndPlaceTokenVal] = useState<string>(''); 
    const phoneInputRef = useRef<any>();

    const { authKey, limits, loading, profiles, countries, getCountries, timezones, getTimezones, userTimezone, startPlaces, endPlaces, getPlaces, setEndPlaces, showToast } = useAppContext();

    const startPlaceRef = useRef<any>();
    const endPlaceRef = useRef<any>();

     useEffect(() => { 
        const effect = async () => {
            getPlaces(authKey.mt, limits.places);
            if(countries.length === 0) await getCountries(); 
            //setLoading(false);
        }
        effect();
    }, [newStartPlaceIsOpen, newEndPlaceIsOpen]);
    
    const toggleType = (e: any) => {
        if(e.detail.value == 'LOOP') {
            setRouteType('LOOP');
            setRouteStartPlaceSrc('saved-place');
            setRouteEndPlaceSrc('saved-place');
            setEndPlaceDisabled(true);
            setEndPlaces(startPlaces);
            if (endPlaceRef.current) endPlaceRef.current.value = startPlaceRef.current.value;
        } else {
            setRouteType('ONE-WAY');
            setRouteStartPlaceSrc('saved-place');
            setRouteEndPlaceSrc('saved-place');
            setEndPlaceDisabled(false);
            let eps:any = [];
            startPlaces.forEach((item:any, index:any, arr:any) => {
                if(startPlaceRef.current && item.placeToken != startPlaceRef.current.value) eps.push(item);
            });
            setEndPlaces(eps);
        }        
    };


    //
    // Toggle the Route Start Place Source
    //
    const toggleRouteStartPlaceSrc = (p: string) => {
        setRouteStartPlaceSrc(p === routeStartPlaceSrc ? '' : p);
        setStartPlaceTokenVal('');
    }; 

    //
    // Toggle the Route End Place Source
    //
    const toggleRouteEndPlaceSrc = (p: string) => {
        setRouteEndPlaceSrc(p === routeEndPlaceSrc ? '' : p);
        setEndPlaceTokenVal('');
    }; 

    const toggleRouteDetailOpen = () => {
        setNewRouteDetailOpen(!newRouteDetailOpen);
    };

    const toggleStartPlaceDetailOpen = () => {
        setNewStartPlaceIsOpen(!newStartPlaceIsOpen);
    };

    const toggleEndPlaceDetailOpen = () => {
        setNewEndPlaceIsOpen(!newEndPlaceIsOpen);
    };

    
    const handleStartPlaceChange = (e: any) => {
        let eps:any = [];
        const placeToken = e.detail.value;

        setStartPlaceTokenVal(placeToken);

        startPlaces.forEach((item:any, index:any, arr:any) => {
            if(endPlaceDisabled || item.placeToken != startPlaceRef.current.value) eps.push(item);
        });

        setEndPlaces(eps);

        if(endPlaceDisabled) {            
            if (endPlaceRef.current) endPlaceRef.current.value = placeToken;
        } else if(endPlaceRef.current?.value == startPlaceRef.current?.value) {
            if (endPlaceRef.current) endPlaceRef.current.value = '';
        }
        
        const selectedPlace = startPlaces.find(
            (place: any) => place.placeToken === String(placeToken)
        );

        if (!selectedPlace) return;

        generateRouteName('routeStartPlaceName', selectedPlace.placeName);
    };


    const handleEndPlaceChange = (e: any) => {
        const placeToken = e.detail.value;
        
        setEndPlaceTokenVal(placeToken);
        const selectedPlace = endPlaces.find(
            (place: any) => place.placeToken === String(placeToken)
        );

        if (!selectedPlace) return;

        console.log(selectedPlace.placeName);
        generateRouteName('routeEndPlaceName', selectedPlace.placeName);
    };


    //
    // Generate the Route Name from the Start and End Places
    //
    const generateRouteName = (source: string, value: string) => {
        if (source === 'routeStartPlaceName') {
            if (routeTextRef.current.value == '') routeTextRef.current.value = value == '' ? '' : value;

            if (routeEndTextRef.current) {
                if (routeTextRef.current.value == '') routeTextRef.current.value = value == '' ? '' : value + ' to ' + routeEndTextRef.current.value;
            } else if (endPlaceRef.current) {
                const selectedEndPlace = endPlaces.find(
                    (place: any) => place.placeToken === String(endPlaceRef.current.value)
                );

                if (!selectedEndPlace) return;

                if (routeTextRef.current.value == '') routeTextRef.current.value = value == '' ? '' : value + ' to ' + selectedEndPlace.placeName;
            }
        }
        
        if (source === 'routeEndPlaceName') {
            if (routeStartTextRef.current) {
                if (routeTextRef.current.value == '') routeTextRef.current.value = value == '' ? '' : routeStartTextRef.current.value + ' to ' + value;
            } else if (startPlaceRef.current) {
                const selectedStartPlace = startPlaces.find(
                    (place: any) => place.placeToken === String(startPlaceRef.current.value)
                );

                if (!selectedStartPlace) return;

                if (routeTextRef.current.value == '') routeTextRef.current.value = value == '' ? '' : selectedStartPlace.placeName + ' to ' + value;
            }
        }   
                
        nameRef.current.value = routeTextRef.current.value;
    };

    const formatPhone = () => {
        const refVal = phoneInputRef.current.value;
        const formattedValue = refVal.replace(/\D/g,'');
        phoneInputRef.current.value = formattedValue;
    };
    
    return (
        <>    
            <IonRow className='ion-no-margin'>
                <IonCol size='12'>
                    <IonLabel color={'dark'}><b>Trail Name or Number</b></IonLabel><br />
                    {/*<IonNote><em>Commute to work, Daily walk in park, Running errands, etc.</em></IonNote>*/}
                </IonCol>
                <IonCol size='12'>
                    <IonInput 
                        autocapitalize='sentences'
                        clearInput={true} 
                        counter 
                        fill='outline' 
                        name='routeName' 
                        onIonInput={(e) => {
                            const value = e.detail.value ?? '';
                            onRouteNameChange?.('routeName', value);
                        }} 
                        placeholder='' 
                        ref={routeTextRef} 
                        type='text' 
                        maxlength={50}></IonInput>                                        
                </IonCol>                                  
            </IonRow>

            <IonRow className='ion-margin-bottom ion-margin-top'>
                <IonCol>
                    <IonText className='link' color={'secondary'} onClick={toggleRouteDetailOpen}>{newRouteDetailOpen ? '- Remove' : '+ Add'} Optional Trail Details</IonText>
                </IonCol>
            </IonRow>
            
            {newRouteDetailOpen &&
              <>                
                <IonRadioGroup name='routeType' onIonChange={toggleType} value={routeType}>   
                    <IonRow className='ion-margin-bottom'>
                        <IonCol size='12' sizeLg='6'>
                            <IonItem lines='none'>
                                <IonRadio className='wrapped'  justify="start" key={1} labelPlacement="end" value='LOOP'>
                                    Round-Trip<br />
                                    <IonNote>Starts and ends at <strong><em>the same trailhead</em></strong></IonNote>
                                </IonRadio>
                            </IonItem>                    
                        </IonCol> 
                        <IonCol size='12' sizeLg='6'>                                         
                            <IonItem lines='none'>
                                <IonRadio className='wrapped' justify="start" key={2} labelPlacement="end" value='ONE-WAY'>
                                    One-Way<br />
                                    <IonNote>Starts and ends at <strong><em>different trailheads</em></strong></IonNote>
                                </IonRadio>
                            </IonItem>
                        </IonCol>                    
                    </IonRow>
                </IonRadioGroup>           

                {routeType != '' &&
                <IonRow> 
                    <IonCol size='12' sizeSm='6'> 
                        <IonCard className='ion-no-margin'>
                            <IonCardContent>
                                <IonLabel color={'dark'}><b>Starting {routeType === 'LOOP' && ' & Ending'} Trailhead</b></IonLabel><br />
                                <IonNote>Select a saved Place or enter a new Place</IonNote>

                                {routeStartPlaceSrc === 'new-place' && 
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonButton 
                                            color={'tertiary'} 
                                            fill={'outline'} 
                                            onClick={() => toggleRouteStartPlaceSrc('saved-place')} >
                                                Select a Saved Place
                                        </IonButton>
                                    </IonCol> 
                                </IonRow>
                                }                                
                                
                                {routeStartPlaceSrc === 'saved-place' && 
                                <IonSelect
                                    className='ion-margin-bottom ion-margin-top'
                                    fill='outline' 
                                    label='Select a Saved Place' 
                                    labelPlacement='stacked' 
                                    name='routeStartPlace' 
                                    onIonChange={handleStartPlaceChange} 
                                    placeholder='Saved Places' 
                                    ref={startPlaceRef}
                                    value={startPlaceTokenVal}>
                                    {startPlaces != undefined &&
                                        startPlaces.map((place:any, index:any) => (
                                        <IonSelectOption key={index} value={place.placeToken}>{place.placeName}</IonSelectOption>
                                    ))}                                            
                                </IonSelect>  
                                }

                                {routeStartPlaceSrc === 'new-place' &&  
                                  <>
                                    <IonRow className='ion-margin-top'>
                                        <IonCol size='12'>
                                            <IonLabel color={'dark'}><b>Enter a New Trailhead Name</b></IonLabel><br />
                                            <IonInput 
                                                autocapitalize='sentences'
                                                className='ion-margin-top' 
                                                counter
                                                fill='outline' 
                                                name='routeStartPlaceName' 
                                                onIonInput={(e) => {
                                                    const value = e.detail.value ?? '';
                                                    generateRouteName?.('routeStartPlaceName', value);
                                                }} 
                                                placeholder='' 
                                                ref={routeStartTextRef}
                                                type='text' 
                                                maxlength={50}></IonInput>                                        
                                        </IonCol>                                  
                                    </IonRow>

                                    <IonRow className='ion-margin-bottom'>
                                        <IonCol>
                                            <IonText className='link' color={'secondary'} onClick={toggleStartPlaceDetailOpen}>{newStartPlaceIsOpen ? '- Remove' : '+ Add'} Optional Trailhead Details</IonText>
                                        </IonCol>
                                    </IonRow>

                                    {newStartPlaceIsOpen &&
                                    <>
                                        <IonRow className='ion-margin-bottom'>
                                            <IonCol size='12'>
                                                <IonLabel color={'dark'}><b>Location</b></IonLabel><br />
                                                <IonNote><em>Include the nearest town, road, and wilderness area (i.e. State Park, National Forest, etc.)</em></IonNote>
                                            </IonCol>
                                            <IonCol size='12'>
                                                <IonInput autocapitalize='sentences' counter fill='outline' name='routeStartPlaceLocation' placeholder='' maxlength={200}></IonInput>     
                                            </IonCol>
                                        </IonRow>
                    
                                        <IonRow className='ion-margin-bottom'>
                                            <IonCol size='12'>
                                                <IonLabel color={'dark'}><b>Google Maps Link</b></IonLabel>
                                            </IonCol>
                                            <IonCol size='12'>
                                                <IonInput fill='outline' name='routeStartPlaceMapLink' placeholder=''></IonInput>                              
                                            </IonCol>
                                        </IonRow>
                    
                                        <IonRow className='ion-margin-bottom'>
                                            <IonCol size='12'>
                                                <IonLabel color={'dark'}><b>Local Emergency Response Agencies</b></IonLabel><br />
                                                <IonNote>Include the name and phone number of the agencies your emergency contact(s) should call. This could be the local police, search and rescue team, etc.</IonNote>
                                            </IonCol>
                                            <IonCol size='12'>
                                                <IonTextarea autoGrow={true} fill='outline' name='routeStartPlaceNotes' placeholder=''></IonTextarea>                               
                                            </IonCol>
                                        </IonRow>
                                      </>
                                    }
                
                                    <hr />
                    
                                    {profiles?.places < limits?.places && 
                                    <IonRow className='ion-margin-bottom'>
                                        <IonCol>
                                            <IonCheckbox color={'secondary'} labelPlacement="end" name='saveRouteStartPlace'>Save this Place</IonCheckbox>
                                        </IonCol>
                                    </IonRow>
                                    }
                                  </>
                                }     

                                {routeStartPlaceSrc === 'saved-place' && 
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonButton 
                                            color={'tertiary'} 
                                            fill={'outline'} 
                                            onClick={() => toggleRouteStartPlaceSrc('new-place')}>
                                                Enter a New Place
                                        </IonButton>                                                                   
                                    </IonCol> 
                                </IonRow>
                                }

                            </IonCardContent>
                        </IonCard>
                    </IonCol>

                    {routeType !== 'LOOP' &&
                    <IonCol size='12' sizeSm='6'> 
                        <IonCard className='ion-no-margin'>
                            <IonCardContent>
                                <IonLabel color={'dark'}><b>Ending Trailhead</b></IonLabel><br />
                                <IonNote>Select a saved Place or enter a new Place</IonNote>

                                {routeEndPlaceSrc === 'new-place' && 
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonButton 
                                            color={'tertiary'} 
                                            fill={'outline'} 
                                            onClick={() => toggleRouteEndPlaceSrc('saved-place')} >
                                                Select a Saved Place
                                        </IonButton>
                                    </IonCol> 
                                </IonRow>
                                }  

                                {routeEndPlaceSrc === 'saved-place' &&  
                                <IonSelect
                                    className='ion-margin-bottom ion-margin-top'
                                    disabled={endPlaceDisabled} 
                                    fill='outline' 
                                    label='Select a Saved Place' 
                                    labelPlacement='stacked' 
                                    name='routeEndPlace' 
                                    onIonChange={handleEndPlaceChange}
                                    placeholder='Saved Places' 
                                    ref={endPlaceRef}
                                    value={endPlaceTokenVal}>
                                    {endPlaces != undefined &&
                                        endPlaces.map((place:any, index:number) => (
                                        <IonSelectOption key={index} value={place.placeToken}>{place.placeName}</IonSelectOption> 
                                    ))}                                            
                                </IonSelect>   
                                } 

                                {routeEndPlaceSrc === 'new-place' &&  
                                <>
                                    <IonRow className='ion-margin-top'>
                                        <IonCol size='12'>
                                            <IonLabel color={'dark'}><b>Enter a New Trailhead Name</b></IonLabel><br />
                                            <IonInput 
                                                autocapitalize='sentences' 
                                                className='ion-margin-top'
                                                counter
                                                fill='outline' 
                                                name='routeEndPlaceName' 
                                                onIonInput={(e) => {
                                                    const value = e.detail.value ?? '';
                                                    generateRouteName?.('routeEndPlaceName', value);
                                                }} 
                                                placeholder='' 
                                                ref={routeEndTextRef}
                                                type='text' 
                                                maxlength={50}></IonInput>                                        
                                        </IonCol>                                  
                                    </IonRow>

                                    <IonRow className='ion-margin-bottom'>
                                        <IonCol>
                                            <IonText className='link' color={'secondary'} onClick={toggleEndPlaceDetailOpen}>{newEndPlaceIsOpen ? '- Remove' : '+ Add'} Optional Trailhead Details</IonText>
                                        </IonCol>
                                    </IonRow>

                                    {newEndPlaceIsOpen &&
                                    <>
                                        <IonRow className='ion-margin-bottom'>
                                            <IonCol size='12'>
                                                <IonLabel color={'dark'}><b>Location</b></IonLabel><br />
                                                <IonNote><em>Include the nearest town, road, and wilderness area (i.e. State Park, National Forest, etc.)</em></IonNote>
                                            </IonCol>
                                            <IonCol size='12'>
                                                <IonInput autocapitalize='sentences' counter fill='outline' maxlength={200} name='routeEndPlaceLocation' placeholder=''></IonInput>                               
                                            </IonCol>
                                        </IonRow>
                    
                                        <IonRow className='ion-margin-bottom'>
                                            <IonCol size='12'>
                                                <IonLabel color={'dark'}><b>Google Maps Link</b></IonLabel>
                                            </IonCol>
                                            <IonCol size='12'>
                                                <IonInput fill='outline' name='routeEndPlaceMapLink' placeholder=''></IonInput>                              
                                            </IonCol>
                                        </IonRow>
                    
                                        <IonRow className='ion-margin-bottom'>
                                            <IonCol size='12'>
                                                <IonLabel color={'dark'}><b>Local Emergency Response Agencies</b></IonLabel><br />
                                                <IonNote>Include the name and phone number of the agencies your emergency contact(s) should call. This could be the local police, search and rescue team, etc.</IonNote>
                                            </IonCol>
                                            <IonCol size='12'>
                                                <IonTextarea autoGrow={true} fill='outline' name='routeEndPlaceNotes' placeholder=''></IonTextarea>                               
                                            </IonCol>
                                        </IonRow>
                                      </>
                                    }
                
                                    <hr />
                    
                                    {profiles?.places < limits?.places && 
                                    <IonRow className='ion-margin-bottom'>
                                        <IonCol>
                                            <IonCheckbox color={'secondary'} labelPlacement="end" name='saveRouteEndPlace'>Save this Place</IonCheckbox>
                                        </IonCol>
                                    </IonRow>
                                    }    
                                  </>
                                }

                                {routeEndPlaceSrc === 'saved-place' && 
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonButton 
                                            color={'tertiary'} 
                                            fill={'outline'} 
                                            onClick={() => toggleRouteEndPlaceSrc('new-place')}>
                                                Enter a New Place
                                        </IonButton>                                                                   
                                    </IonCol> 
                                </IonRow>
                                }
                            </IonCardContent>
                        </IonCard>       
                    </IonCol>
                    }
                </IonRow>
                }

                <IonRow className='ion-margin-bottom ion-margin-top'>
                    <IonCol size='12'>
                        <IonLabel color={'dark'}><b>Route Distance</b></IonLabel>
                    </IonCol>
                    <IonCol size='8' sizeSm='3'>
                        <IonInput fill='outline' name='routeDistance' placeholder='Distance' type='number' step='.1'></IonInput>
                    </IonCol>
                    <IonCol size='4' sizeSm='3'>
                        <IonSelect fill='outline' label='Units' labelPlacement='stacked' name='routeDistanceUnits' placeholder='Units' value={'MI'}>  
                            <IonSelectOption value='MI'>MI</IonSelectOption>
                            <IonSelectOption value='KM'>KM</IonSelectOption>
                        </IonSelect>
                    </IonCol>  
                    <IonCol sizeXs='12' sizeSm='6'>
                        <IonSelect fill='outline' label='Travel Modes' labelPlacement='stacked' name='routeCategory' placeholder='You can select multiple' multiple={true}>
                            <IonSelectOption value='1'>Hiking/Backpacking</IonSelectOption>
                            <IonSelectOption value='2'>Horseback Riding</IonSelectOption>
                            <IonSelectOption value='3'>Moto Riding</IonSelectOption>
                            <IonSelectOption value='4'>Mtn Biking</IonSelectOption>
                            <IonSelectOption value='5'>Trail Running</IonSelectOption>
                        </IonSelect>
                    </IonCol>                                 
                </IonRow>

                <IonRow className='ion-margin-bottom'>
                    <IonCol size='12'>
                        <IonLabel color={'dark'}><b>Route Description, Waypoints & Campsites</b></IonLabel><br />
                        <IonNote>This can be a description of the route and/or a list of points along your route.</IonNote>
                    </IonCol>
                    <IonCol size='12'>
                        <IonTextarea autocapitalize='sentences' autoGrow={true} fill='outline' name='routeWaypoints' placeholder=''></IonTextarea>
                    </IonCol>
                </IonRow>
            </>
            }

            <hr />

            {profiles?.routes < limits?.routes && 
            <IonRow className='ion-margin-bottom'>
                <IonCol>
                    <IonCheckbox color={'secondary'} labelPlacement="end" name='saveRoute'>Save this Trail</IonCheckbox>
                </IonCol>
            </IonRow>
            }        
        </>
    );
};

export default TrailCreateEmbed;